(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root.kotlin_org_axessimpact_protocol_api_domain = factory(typeof kotlin_org_axessimpact_protocol_api_domain === 'undefined' ? {} : kotlin_org_axessimpact_protocol_api_domain);
}(this, function (_) {
  'use strict';
  //region block: pre-declaration
  //endregion
  function ProtocolCreateResultDTO() {
  }
  ProtocolCreateResultDTO.$metadata$ = {
    simpleName: 'ProtocolCreateResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolGetAllQueryDTO() {
  }
  ProtocolGetAllQueryDTO.$metadata$ = {
    simpleName: 'ProtocolGetAllQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolGetAllQueryResultDTO() {
  }
  ProtocolGetAllQueryResultDTO.$metadata$ = {
    simpleName: 'ProtocolGetAllQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolGetQueryDTO() {
  }
  ProtocolGetQueryDTO.$metadata$ = {
    simpleName: 'ProtocolGetQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolGetQueryResultDTO() {
  }
  ProtocolGetQueryResultDTO.$metadata$ = {
    simpleName: 'ProtocolGetQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolGetStepsQueryDTO() {
  }
  ProtocolGetStepsQueryDTO.$metadata$ = {
    simpleName: 'ProtocolGetStepsQueryDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolGetStepsQueryResultDTO() {
  }
  ProtocolGetStepsQueryResultDTO.$metadata$ = {
    simpleName: 'ProtocolGetStepsQueryResultDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolDTO() {
  }
  ProtocolDTO.$metadata$ = {
    simpleName: 'ProtocolDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolStatusDTO() {
  }
  ProtocolStatusDTO.$metadata$ = {
    simpleName: 'ProtocolStatusDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolStatusValues() {
    ProtocolStatusValues_instance = this;
  }
  ProtocolStatusValues.prototype.created = function () {
    return 'Created';
  };
  ProtocolStatusValues.$metadata$ = {
    simpleName: 'ProtocolStatusValues',
    kind: 'object',
    interfaces: []
  };
  var ProtocolStatusValues_instance;
  function ProtocolStatusValues_getInstance() {
    if (ProtocolStatusValues_instance == null)
      new ProtocolStatusValues();
    return ProtocolStatusValues_instance;
  }
  function ProtocolStepDTO() {
  }
  ProtocolStepDTO.$metadata$ = {
    simpleName: 'ProtocolStepDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolTaskDTO() {
  }
  ProtocolTaskDTO.$metadata$ = {
    simpleName: 'ProtocolTaskDTO',
    kind: 'interface',
    interfaces: []
  };
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$features = $org$axess$f2$protocol$api$domain.features || ($org$axess$f2$protocol$api$domain.features = {});
    var $org$axess$f2$protocol$api$domain$features$command = $org$axess$f2$protocol$api$domain$features.command || ($org$axess$f2$protocol$api$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$features = $org$axess$f2$protocol$api$domain.features || ($org$axess$f2$protocol$api$domain.features = {});
    var $org$axess$f2$protocol$api$domain$features$query = $org$axess$f2$protocol$api$domain$features.query || ($org$axess$f2$protocol$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$features = $org$axess$f2$protocol$api$domain.features || ($org$axess$f2$protocol$api$domain.features = {});
    var $org$axess$f2$protocol$api$domain$features$query = $org$axess$f2$protocol$api$domain$features.query || ($org$axess$f2$protocol$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$features = $org$axess$f2$protocol$api$domain.features || ($org$axess$f2$protocol$api$domain.features = {});
    var $org$axess$f2$protocol$api$domain$features$query = $org$axess$f2$protocol$api$domain$features.query || ($org$axess$f2$protocol$api$domain$features.query = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$model = $org$axess$f2$protocol$api$domain.model || ($org$axess$f2$protocol$api$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$model = $org$axess$f2$protocol$api$domain.model || ($org$axess$f2$protocol$api$domain.model = {});
    Object.defineProperty($org$axess$f2$protocol$api$domain$model, 'ProtocolStatusValues', {
      configurable: true,
      get: ProtocolStatusValues_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$model = $org$axess$f2$protocol$api$domain.model || ($org$axess$f2$protocol$api$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$f2 = $org$axess.f2 || ($org$axess.f2 = {});
    var $org$axess$f2$protocol = $org$axess$f2.protocol || ($org$axess$f2.protocol = {});
    var $org$axess$f2$protocol$api = $org$axess$f2$protocol.api || ($org$axess$f2$protocol.api = {});
    var $org$axess$f2$protocol$api$domain = $org$axess$f2$protocol$api.domain || ($org$axess$f2$protocol$api.domain = {});
    var $org$axess$f2$protocol$api$domain$model = $org$axess$f2$protocol$api$domain.model || ($org$axess$f2$protocol$api$domain.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_axessimpact_protocol_api_domain.js.map